import { render, staticRenderFns } from "./ConfigurationBlocked.vue?vue&type=template&id=42dc3cd2&lang=pug"
import script from "./ConfigurationBlocked.vue?vue&type=script&lang=js"
export * from "./ConfigurationBlocked.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationBlocked.vue?vue&type=style&index=0&id=42dc3cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports